<rt-report-parameters
    [controlNames]="controlNames"
    (getReport)="onGetReportClick($event)"
    (cancelReport)="onCancelClick()"
>
</rt-report-parameters>

<div *ngIf="displayReport">
    <div class="railroad-grid-container">
        <dx-data-grid
            bds-grid
            id="bdsReportGrid"
            [dataSource]="gridSource"
            height="80vh"
            minHeight="200px"
            [showBorders]="true"
            [columnAutoWidth]="true"
            [allowColumnResizing]="true"
        >
            <dxo-scrolling mode="virtual" showScrollbar="always"></dxo-scrolling>
            <dxo-paging [pageSize]="50"></dxo-paging>
            <dxo-filter-row [visible]="false"></dxo-filter-row>
            <dxo-header-filter [visible]="false"></dxo-header-filter>

            <dxi-column caption="Road" dataField="road"></dxi-column>
            <dxi-column caption="Begin City" dataField="beg_erpc_city"></dxi-column>
            <dxi-column caption="Begin State" dataField="beg_erpc_state"></dxi-column>
            <dxi-column caption="End City" dataField="end_erpc_city"></dxi-column>
            <dxi-column caption="End State" dataField="end_erpc_state"></dxi-column>
            <dxi-column caption="Interchange Road" dataField="interchange_road"></dxi-column>
            <dxi-column
                caption="Benchmark Hours"
                dataField="benchmark_hours"
                dataType="number"
                alignment="right"
                [format]="{ type: 'fixedPoint', precision: 0 }"
            ></dxi-column>

            <dxi-column
                caption="Total Activity"
                dataField="total_activity"
                dataType="number"
                alignment="right"
                [format]="{ type: 'fixedPoint', precision: 0 }"
            ></dxi-column>

            <dxi-column caption="Actual Activity" alignment="center">
                <dxi-column
                    caption="#"
                    dataField="actual_activity"
                    dataType="number"
                    alignment="right"
                    [format]="{ type: 'fixedPoint', precision: 0 }"
                ></dxi-column>
                <dxi-column
                    caption="%"
                    dataField="actual_percent"
                    dataType="number"
                    alignment="right"
                    [format]="{ type: 'fixedPoint', precision: 1 }"
                ></dxi-column>
            </dxi-column>

            <dxi-column caption="Transit Time" alignment="center">
                <dxi-column
                    caption="Avg"
                    dataField="avg_transit_time"
                    dataType="number"
                    alignment="right"
                    [format]="{ type: 'fixedPoint', precision: 0 }"
                ></dxi-column>
                <dxi-column
                    caption="Max"
                    dataField="max_transit_time"
                    dataType="number"
                    alignment="right"
                    [format]="{ type: 'fixedPoint', precision: 0 }"
                ></dxi-column>
                <dxi-column
                    caption="Min"
                    dataField="min_transit_time"
                    dataType="number"
                    alignment="right"
                    [format]="{ type: 'fixedPoint', precision: 0 }"
                ></dxi-column>
            </dxi-column>

            <dxi-column
                caption="Variance"
                dataField="avg_variance"
                dataType="number"
                alignment="right"
                [format]="{ type: 'fixedPoint', precision: 0 }"
            ></dxi-column>
            <dxi-column
                caption="Std Dev"
                dataField="std_deviation"
                dataType="number"
                alignment="right"
                [format]="{ type: 'fixedPoint', precision: 0 }"
            ></dxi-column>

            <dxi-column caption="Early Shipments" alignment="center">
                <dxi-column
                    caption="#"
                    dataField="early_ship_no"
                    dataType="number"
                    alignment="right"
                    [format]="{ type: 'fixedPoint', precision: 0 }"
                ></dxi-column>
                <dxi-column
                    caption="%"
                    dataField="early_ship_per"
                    dataType="number"
                    alignment="right"
                    [format]="{ type: 'fixedPoint', precision: 1 }"
                ></dxi-column>
            </dxi-column>
        </dx-data-grid>
    </div>
</div>
